import { Box, IconButton,Tooltip } from "@mui/material";
import { motion } from "framer-motion";
import React, { ReactNode } from "react";

export type IconAction = {
    icon: ReactNode;
    tooltip?: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    hoverColor?: string;
};

type IconGroupProps = {
    icons: IconAction[];
    sx?: object;
    defaultColor?: string;       // default #6c6c6c
    defaultHoverColor?: string;  // default #000
    active?: boolean;
};

const IconGroup: React.FC<IconGroupProps> = (
    {
        icons,
        sx,
        defaultColor = "#6c6c6c",
        defaultHoverColor = "#000",
        active = false,
}) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                width: "fit-content",
                height: "fit-content",
                gap: "2px",
                ...sx,
            }}
        >
            {icons.map((iconAction, idx) => {
                const { icon, tooltip, onClick, hoverColor } = iconAction;

                const content = (
                    <motion.div
                        whileHover={{ scale: 1.15 }}
                        transition={{ type: "spring", stiffness: 300, damping: 15 }}
                    >
                        <IconButton
                            key={idx}
                            tabIndex={-1}
                            disableRipple
                            onMouseDownCapture={(e) => e.stopPropagation()}
                            onClick={(e) => {
                                e.stopPropagation();
                                onClick?.(e);
                            }}
                            sx={{
                                color: defaultColor,
                                transition: "color 0.2s ease",
                                "&:hover": {
                                    color: hoverColor || defaultHoverColor,
                                },
                            }}
                        >
                            {icon}
                        </IconButton>
                    </motion.div>
                );

                return tooltip ? (
                    <Tooltip key={idx} title={tooltip} disableInteractive>
                        {content}
                    </Tooltip>
                ) : (
                    <React.Fragment key={idx}>{content}</React.Fragment>
                );
            })}
        </Box>
    );
};

export default IconGroup;